import { render } from "./RegistroUsuarioGrupo.vue?vue&type=template&id=fad30fce&scoped=true"
import script from "./RegistroUsuarioGrupo.vue?vue&type=script&lang=js"
export * from "./RegistroUsuarioGrupo.vue?vue&type=script&lang=js"

import "./RegistroUsuarioGrupo.vue?vue&type=style&index=0&id=fad30fce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fad30fce"]])

export default __exports__